import dispatcher from '../dispatcher';

var handleKey = function(e) {
	if (e.keyCode === 35) {
		dispatcher.dispatch({
			type: 'scroll-to',
			position: 'end'
		})
	} else if (e.keyCode === 36) {
		dispatcher.dispatch({
			type: 'scroll-to',
			position: 'home'
		})
	}
}

var _init = function() {
	document.addEventListener('keydown', handleKey);
}

_init();